export const teamMembersTranslation = {
  en: {
    "S.No": "S.No",
    Name: "Name",
    "Job Title": "Job Title",
    Description: "Description",
    Avatar: "Avatar",
    Status: "Status",
    "Created At": "Created At",
    Actions: "Actions",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    "Team Members": "Team Members",
    "+ Add Team Member": "+ Add Team Member",
    "Search by name...": "Search by name...",
    "Name (EN)": "Name (EN)",
    "Name (AR)": "Name (AR)",
    "Job Title (EN)": "Job Title (EN)",
    "Job Title (AR)": "Job Title (AR)",
    "Description (EN)": "Description (EN)",
    "Description (AR)": "Description (AR)",
    "LinkedIn URL": "LinkedIn URL",
    "X URL": "X URL",
    Active: "Active",
    Inactive: "Inactive",
    "Edit Team Member": "Edit Team Member",
    "Add New Team Member": "Add New Team Member",
    "Update Team Member": "Update Team Member",
    "Add Team Member": "Add Team Member",
    "Are you sure you want to delete team member '{{name}}'?":
      "Are you sure you want to delete team member '{{name}}'?",
    Cancel: "Cancel",
    Delete: "Delete",
    "This action cannot be undone.": "This action cannot be undone.",
    "N/A": "N/A",
  },
  ar: {
    "S.No": "رقم",
    Name: "الاسم",
    "Job Title": "المسمى الوظيفي",
    Description: "الوصف",
    Avatar: "الصورة الرمزية",
    Status: "الحالة",
    "Created At": "تاريخ الإنشاء",
    Actions: "الإجراءات",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    "Team Members": "أعضاء الفريق",
    "+ Add Team Member": "+ إضافة عضو فريق",
    "Search by name...": "البحث حسب الاسم...",
    "Name (EN)": "الاسم (EN)",
    "Name (AR)": "الاسم (AR)",
    "Job Title (EN)": "المسمى الوظيفي (EN)",
    "Job Title (AR)": "المسمى الوظيفي (AR)",
    "Description (EN)": "الوصف (EN)",
    "Description (AR)": "الوصف (AR)",
    "LinkedIn URL": "رابط LinkedIn",
    "X URL": "رابط X",
    Active: "نشط",
    Inactive: "غير نشط",
    "Edit Team Member": "تعديل عضو الفريق",
    "Add New Team Member": "إضافة عضو فريق جديد",
    "Update Team Member": "تحديث عضو الفريق",
    "Add Team Member": "إضافة عضو فريق",
    "Are you sure you want to delete team member '{{name}}'?":
      "هل أنت متأكد أنك تريد حذف عضو الفريق '{{name}}'؟",
    Cancel: "إلغاء",
    Delete: "حذف",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    "N/A": "غير متوفر",
  },
};
